import { gql } from 'urql';

export default gql`
  mutation ReplaceLostStolenCard(
    $idempotencyId: IdempotencyToken!
    $input: ReplaceLostStolenCardInput!
  ) {
    replaceLostStolenCard(idempotencyId: $idempotencyId, input: $input) {
      ... on ReplaceLostStolenCardSuccess {
        __typename
        title
        message
      }
      ... on ReplaceLostStolenCardError {
        __typename
        title
        message
      }
    }
  }
`;
